/**
 * @generated SignedSource<<7a96c2229f3c9536a086f0b91db9dca0>>
 * @relayHash 9d3c37bf65541ad9bf7b48bb05dbf32a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c96e69c73eb94bcc48082824b236accc30896a1d19ad37b1a9471b04ef8fefb6

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraSoftwareTimelineAppQuery } from './JiraSoftwareTimelineAppQuery.graphql';

const node: PreloadableConcreteRequest<JiraSoftwareTimelineAppQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "c96e69c73eb94bcc48082824b236accc30896a1d19ad37b1a9471b04ef8fefb6",
    "metadata": {},
    "name": "JiraSoftwareTimelineAppQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
